import type { BundleItem } from '../types/artTherapy';
import { pricing } from './babyShowerPricing';

/** Producto principal. Para cambiar la portada, reemplazá la URL de `image`. */
export const bundleMainProduct = {
  badge: 'Producto principal',
  title: '30 juegos imprimibles para Baby Shower',
  description: 'Tené resuelta la diversión con juegos ya armados y diseñados: bingo, trivias, predicciones y propuestas emotivas para que amigas y familiares compartan un momento inolvidable.',
  benefits: ['30 juegos imprimibles.', 'Instrucciones de uso.', 'Hojas y tarjetas imprimibles según cada actividad.', 'Versiones rosa y celeste incluidas.'],
  image: 'https://cdn.magicpatterns.com/uploads/emYoEvBmTqcbQs5fXzqit9/Dulce_Recuerdo__Juegos_de_Baby_Shower.png'
};
export const bundleBonusesTitle = '¡Y además te llevás 4 bonos de regalo!';

/**
 * Los 4 bonos de regalo, todos con el mismo diseño de tarjeta.
 * Agregá, quitá o reordená bonos editando esta lista.
 */
export type BundleBonus = BundleItem & {
  image: string;
  /** Precio individual de referencia (se define en babyShowerPricing.ts) */
  price: number;
};
export const bundleBonuses: BundleBonus[] = [{
  badge: 'Bono de regalo',
  title: '50 juegos y dinámicas en movimiento',
  description: 'Actividades grupales para sumar diversión.',
  price: pricing.bonuses.dinamicas,
  image: 'https://cdn.magicpatterns.com/uploads/r9w6fYC1KpZGDSFqe1bUaf/50_Juegos_y_Dinamicas_para_Baby_Shower.png'
}, {
  badge: 'Bono de regalo',
  title: 'Guía de la organizadora',
  description: 'Organizá y dirigí los juegos con confianza.',
  price: pricing.bonuses.guia,
  image: 'https://cdn.magicpatterns.com/uploads/2R8ruR1uvbcLNFyqbrRbJD/guia_de_la_organizadora_de_baby_shower.png'
}, {
  badge: 'Bono de regalo',
  title: 'Tres planes de juegos',
  description: 'Cronogramas listos de 60, 90 y 120 minutos.',
  price: pricing.bonuses.planes,
  image: 'https://cdn.magicpatterns.com/uploads/eL3MCrCHqLBs7rMHFAoREh/Tres_planes_de_juegos_para_celebrar.png'
}, {
  badge: 'Bono de regalo',
  title: 'Checklist de preparación e impresión',
  description: 'Todo lo necesario para llegar preparada.',
  price: pricing.bonuses.checklist,
  image: 'https://cdn.magicpatterns.com/uploads/iGiPNzQeEjc3nWidWz3jG5/Checklist_para_un_Baby_Shower_Perfecto.png'
}];